import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const Row = ({ t, i, builtins, onMap }) => {
  const [tok, setTok] = useState('SERIAL');
  const [custom, setCustom] = useState('');
  return (
    <tr className="border-t border-slate-100" data-testid={`fp-text-row-${i}`}>
      <td className="py-1 pr-2 text-sm max-w-[220px] truncate" title={t.text}>{t.text}</td>
      <td className="pr-2">
        <select value={tok} onChange={(e) => setTok(e.target.value)} className="h-8 border border-slate-200 rounded-sm text-xs px-1" data-testid={`fp-text-token-${i}`}>
          {Object.keys(builtins).filter(k => k !== 'QR').map(k => <option key={k} value={k}>{k}</option>)}
          <option value="__custom__">Custom field…</option>
        </select>
        {tok === '__custom__' && <Input value={custom} onChange={(e) => setCustom(e.target.value)} placeholder="e.g. VOLTAGE" className="h-8 rounded-sm mono inline-block w-32 ml-1" data-testid={`fp-text-custom-${i}`} />}
      </td>
      <td><Button size="sm" variant="outline" className="h-7 rounded-sm" onClick={() => onMap(t.text, tok === '__custom__' ? custom : tok)} data-testid={`fp-text-map-${i}`}>Make field</Button></td>
    </tr>
  );
};

// Turns literal text in an uploaded design into {{PLACEHOLDERS}} (for SVGs exported without tokens).
export const DesignTextMapper = ({ api, template, builtins, onChanged }) => {
  const [d, setD] = useState(null);
  const load = () => api().get(`/faceplates/${template.id}/texts`).then(r => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, [template.id, template.version]); // eslint-disable-line react-hooks/exhaustive-deps
  const map = async (find, token) => {
    if (!token) { toast.error('Enter a field name'); return; }
    try { const r = await api().post(`/faceplates/${template.id}/map-text`, { find, token }); toast.success(`"${find}" is now {{${token.toUpperCase()}}} (${r.data.replaced}×)`); onChanged(r.data.template); }
    catch (e) { toast.error(e.response?.data?.detail || 'Could not map text'); }
  };
  if (!d) return null;
  const literal = d.texts.filter(t => !t.is_placeholder);
  return (
    <div data-testid="fp-text-mapper">
      <p className="text-sm font-semibold mb-1">Text in your design</p>
      {d.has_paths_only && <p className="text-xs text-amber-700" data-testid="fp-text-outlines-warning">No live text found. The text was probably converted to outlines. Re-export with the variable text kept as text.</p>}
      {!d.has_paths_only && !literal.length && <p className="text-xs text-slate-400">All text in the design is already a placeholder.</p>}
      {literal.length > 0 && (
        <>
          <p className="text-[11px] text-slate-500 mb-1">Pick the sample text that should change on each faceplate (e.g. "SN-000000") and turn it into a field.</p>
          <table className="w-full"><tbody>{literal.slice(0, 40).map((t, i) => <Row key={t.text} t={t} i={i} builtins={builtins || {}} onMap={map} />)}</tbody></table>
        </>
      )}
    </div>
  );
};

export default DesignTextMapper;
